import { FC } from 'react';

import TextAreaStyled, { PropsTextAreaProps } from './styles';

const TextAreaField: FC<PropsTextAreaProps> = (props) => <TextAreaStyled {...props} />;

export default TextAreaField;
